import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'arrow-elbow-left', 'ArrowElbowLeft', [["path",{"d":"M3 14v-6h6","key":"svg-0"}],["path",{"d":"M3 8l9 9l9 -9","key":"svg-1"}]]);